import { PersonalizedProductsModelNames } from 'src/gql/graphql';
import { GetRecommendationsFallback, Options, Scenarios } from './recommendations.types';
import { usePersonalizedItemsV2, UsePersonalizedItemsV2Return } from './use-personalized-items-v2';

export function useSimilarItems(
  getRecommendationsFallback: GetRecommendationsFallback,
  itemId: string,
  scenario: Scenarios,
  options: Options
): UsePersonalizedItemsV2Return {
  return usePersonalizedItemsV2(getRecommendationsFallback, [itemId], PersonalizedProductsModelNames.relatedItems, {
    ...options,
    excludeProducts: [itemId],
  });
}
